import { Admission } from '@domain/admission';
import { Invitation } from '@domain/invitation';
import { Pass } from '@domain/passes';
import { fromBackend } from '@utils/map-date/from-backend';
import { toBackend } from '@utils/map-date/to-backend';
import moment from 'moment-timezone';

export const formatValidTimeToBackend = ({
  formValidFrom,
  formValidFromTime,
  formValidUntil,
  formValidUntilTime,
  offer,
  timezone,
}: {
  formValidFrom?: moment.Moment | null;
  formValidFromTime?: string;
  formValidUntil?: moment.Moment | null;
  formValidUntilTime?: string;
  offer?: Admission | Pass | Invitation | null;
  timezone: string;
}) => {
  let startHours = 0;
  let startMinutes = 0;
  if (formValidFromTime) {
    startHours = parseInt(formValidFromTime.split(':')[0]);
    startMinutes = parseInt(formValidFromTime.split(':')[1]);
  } else if (offer?.checkInTime?.validFrom) {
    startHours = fromBackend(offer.checkInTime.validFrom, timezone).hours();
    startMinutes = fromBackend(offer.checkInTime?.validFrom, timezone).minutes();
  }

  let endHours = 0;
  let endMinutes = 0;
  if (formValidUntilTime) {
    endHours = parseInt(formValidUntilTime.split(':')[0]);
    endMinutes = parseInt(formValidUntilTime.split(':')[1]);
  } else if (offer?.checkInTime?.validUntil) {
    endHours = fromBackend(offer.checkInTime?.validUntil, timezone).hours();
    endMinutes = fromBackend(offer.checkInTime?.validUntil, timezone).minutes();
  }

  let validFromTime = null;
  if (formValidFrom)
    validFromTime = toBackend(moment(formValidFrom).tz(timezone).hours(startHours).minutes(startMinutes));
  else if (offer?.checkInTime?.validFrom)
    validFromTime = toBackend(
      fromBackend(offer.checkInTime.validFrom, timezone).hours(startHours).minutes(startMinutes)
    );

  let validUntilTime = null;
  if (formValidUntil)
    validUntilTime = toBackend(moment(formValidUntil).tz(timezone).hours(endHours).minutes(endMinutes));
  else if (offer?.checkInTime?.validUntil)
    validUntilTime = toBackend(fromBackend(offer.checkInTime.validUntil, timezone).hours(endHours).minutes(endMinutes));

  return {
    validFrom: formValidFrom === null ? null : validFromTime,
    validUntil: formValidUntil === null ? null : validUntilTime,
  };
};
